export default __webpack_public_path__ + "static/media/jap-ecommerceImg_6.266cd3a1.png";